module.exports = __webpack_public_path__ + "img/arrow.c5573ca5.png";